<div id="infra">
  <div class="container-fluid">
      <div class="row">
          <div class="col-12">
              <div class="card shadow-lg inner-card">
                  <h4 class="card-title text-center">Transport</h4>
                  <div class="card-body">
                    <p class="inner-lead">Welcome to our school transportation system!
                      We understand that getting to and from school can be a challenge for many families, which is why we offer a safe and reliable transportation service for our students.
                      We are committed to providing a transportation system that is both safe and affordable for our families.
                      </p>
                      <p class="inner-lead">At our school, we understand that transportation can be a significant barrier for students to attend school regularly, which is why we provide a reliable and efficient transportation system. Our transportation services are designed to ensure that students arrive at school safely and on time. We have a fleet of well-maintained buses that are equipped with safety features such as GPS tracking and seat belts, ensuring that our students are secure during their commutes.
                      </p>
                      <div class="row">
                        <div class="col-12 col-md-6 mb-4 text-center" *ngFor="let img of imgUrl;">
                            <a href="{{img}}" data-lightbox="Transport"><img [src]="img" alt="Transport" class="img-fluid rounded"></a>
                        </div>
                      </div>
                  </div>
              </div>

          </div>
      </div>

     
  </div>
</div>